module.exports = __webpack_public_path__ + "static/media/4@2x.2e1a90a3.png";